/** Clear Zerobuild store auth persisted in the browser. */
export function clearStoreSession() {
  try {
    localStorage.removeItem("storeAccessToken");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("currentUser");
    localStorage.removeItem("storeDealerReferral");
  } catch {
    // ignore
  }
}

export function storeAccountUnsupportedWhatsAppUrl() {
  const text = encodeURIComponent("need help with my account");
  return `https://wa.me/919150469996?text=${text}`;
}
